import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { init, destroy } from './../casino/explore.js';
import Bundle from './bundle.js';

class Explore extends Component {

	componentWillMount() {
		init(document.getElementById('section1'));
	}

	componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	}

	componentWillUnmount() {
		destroy();
	}

	render() {
		return (
			<Route path="/casino/explore/:bundle" component={Bundle} />
		);
	}
}

export default Explore;




// WEBPACK FOOTER //
// ./mobile-core/src/components/explore.js